import type SchedulingAssistantState from '../store/schema/SchedulingAssistantState';
import { getStore } from '../store/store';

export function getSchedulingAssistantState(viewStateId: string): SchedulingAssistantState {
    const state = getStore().viewStates.get(viewStateId);
    if (state) {
        return state;
    } else {
        throw new Error('Scheduling Assistant state missing for id: ' + viewStateId);
    }
}
